var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-portfolio container mt-5"},[_c('h1',{staticClass:"text-center"},[_vm._v("\n        Add Portfolio\n    ")]),_c('add')],1)}
var staticRenderFns = []

export { render, staticRenderFns }